<template>
  <div>
    <div
      :class="wrapperClass"
    >
      <span
        v-for="tab in tabs"
        :key="tab"
        :class="getTabClass(tab)"
        @click="openTab(tab)"
      >
        {{ tab }}
        <i
          v-if="tabsWithErrors.includes(tab)"
          class="fas fa-exclamation-triangle"
        ></i>
      </span>
    </div>
    <div v-for="tab in tabs" v-show="selected === tab" :key="tab">
      <slot :name="tab"></slot>
    </div>
  </div>
</template>
<script>
import { twJoin, twMerge } from 'tailwind-merge';

export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeByDefault: {
      type: String,
      required: false,
    },
    variant: { type: String, default: 'base' },
    tabsWithErrors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    tabs() {
      this.selected = this.tabs[0];
    },
  },
  mounted() {
    const tab = this.activeByDefault || this.tabs[0];
    this.openTab(tab);
  },
  computed: {
    wrapperClass() {
      const baseClass = 'flex border-b';
      const variantClass = {
        base: 'border-grey-200',
        dark: 'border-secondary'
      };
      return twJoin(baseClass, variantClass[this.variant])
    }
  },
  methods: {
    openTab(tab) {
      this.selected = tab;
      this.$emit('tab-change', tab);
    },
    getTabClass(tab) {
      const baseClass = 'p-4 margin-b-minus text-sm cursor-pointer';
      const errorClass = this.tabsWithErrors.includes(tab) ? 'text-danger' : '';
      const selectedClass = tab === this.selected ? 'text-primary border-b-2 border-primary' : '';
      const variantClass = {
        base: 'text-grey-500',
        dark: 'text-secondary-invert'
      };
      return twMerge(baseClass, variantClass[this.variant], selectedClass, errorClass);
    }
  },
};
</script>
